/**
 * Android System WebView does not touch-scroll an inner scroller when `div#root` is
 * `overflow: hidden`.
 *
 * The layout scrolls inside Radix's `#authenticated-layout-viewport` (an `overflow-y: scroll`
 * element), and `index.css` clips `div#root` with `overflow: hidden`. In the mobile app's
 * Android WebView (Chromium 134, reproduced on Android 16) that combination swallows every touch
 * drag and every mouse wheel: the page receives `touchstart`/`touchmove`, the browser then
 * cancels the pointer, and `scrollTop` never moves, although setting `scrollTop` from script
 * works and the scrollbar is drawn. It reads as "the screen won't scroll" (Inspiration Feed,
 * Media Library, Request Edit) and iOS is unaffected.
 *
 * Isolated on the live page: with `#root` overflow-hidden a real drag leaves scrollTop at 0;
 * with `#root` overflow-visible the same drag scrolls. The inner wrapper's own
 * `overflow-hidden` is harmless, so only the root needs to change. `html`, `body` and `#root`
 * are already `h-full`, so the document still cannot scroll on its own.
 *
 * Scoped to the Android WebView on purpose: iOS and desktop browsers are unaffected by the bug
 * and keep the clipping they have today.
 */
export const ANDROID_WEBVIEW_CLASS = 'android-webview';

export const shouldApplyAndroidWebViewScrollFix = ({
  hasNativeMessageChannel,
  userAgent,
}: {
  /** True when the React Native WebView bridge (`window.ReactNativeWebView`) is present. */
  hasNativeMessageChannel: boolean;
  userAgent: string | undefined;
}): boolean => hasNativeMessageChannel && /Android/i.test(userAgent ?? '');
